import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_CodeGeneratorIssues = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Issues in the design of code generator - Target Machine"
    videos={[
      "https://www.youtube.com/embed/CrdVTw4JaiQ",
      "https://www.youtube.com/embed/6dEYkK8fKEA",
    ]}
    takeaways={[]}
    questions={[
      "What are the main challenges in designing a code generator for a compiler? How does the code generator handle issues like target architecture compatibility, code quality and efficient register allocation?"
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_CodeGeneratorIssues;
